module.exports = __webpack_public_path__ + "static/about-investition2-35cd00759014e5ff4426c023e8432b71.jpg";